import React from 'react';
import './FormerDeans.css';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const FormerDeans = () => {
  const { t } = useTranslation();
  const deans = t('former_deans.deans', { returnObjects: true });

  return (
    <div className="former-deans-page">
      {/* Video Header */}
      <div className="video-header-container">
        <video
          className="video-header"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/fenfakultesivideo.mp4" type="video/mp4" />
          {t('former_deans.video_not_supported')}
        </video>
        <div className="video-overlay">
          <div className="video-content">
            <motion.h1 
              className="video-title"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
            >
              {t('former_deans.title')}
            </motion.h1>
            <motion.p 
              className="video-subtitle"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.8 }}
            >
              {t('former_deans.subtitle')}
            </motion.p>
          </div>
        </div>
      </div>
      <div className="deans-hero">
        <motion.h1 
          className="deans-title"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {t('former_deans.title')}
        </motion.h1>
        <motion.p 
          className="deans-desc"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          {t('former_deans.description')}
        </motion.p>
      </div>

      <motion.div 
        className="deans-grid"
        initial="hidden"
        animate="visible"
        variants={{
          visible: { transition: { staggerChildren: 0.08 } },
          hidden: {}
        }}
      >
        {deans && deans.map((dean, i) => (
          <motion.div
            className="dean-card"
            key={dean.name}
            variants={{
              hidden: { opacity: 0, y: 40 },
              visible: { opacity: 1, y: 0, transition: { type: 'spring', stiffness: 80 } }
            }}
            whileHover={{ scale: 1.04, boxShadow: '0 8px 32px 0 rgba(102,126,234,0.18)' }}
          >
            <div className="dean-photo">
              {dean.photo ? (
                <img src={dean.photo} alt={dean.name} />
              ) : (
                <div className="dean-placeholder">
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="8" r="5" fill="#e2e8f0" />
                    <ellipse cx="12" cy="18" rx="8" ry="5" fill="#e2e8f0" />
                  </svg>
                </div>
              )}
            </div>
            <div className="dean-info">
              <div className="dean-name">{dean.name}</div>
              <div className="dean-period">{dean.period}</div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default FormerDeans;